import { AppState } from '../../app/state/AppState';
import { IUserSettings } from '../../ts/models/IUserSettings';

export function selectUserSettings(state: AppState, domainName: string, userName: string): IUserSettings {
  return state.userSettings[domainName] ? state.userSettings[domainName][userName] : undefined;
}